import { Directive, Input, Output, EventEmitter } from '@angular/core';
import { ProjectItemComponent } from './project-item.component';
import { FormControl, FormGroup } from '@angular/forms';

@Directive()
export abstract class ProjectItemWithSelectionComponent extends ProjectItemComponent {

    @Input() currentItem: string;
    @Input() readOnly: boolean = false;
    @Output() selectedItem = new EventEmitter<FormGroup>();

    onItemSelectionChange(event) {
        this.selectedItem.next(event);
        return false;
    }

}